import {Box, CardHeader, Link, Switch} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

const ToggleFilter = ({
  title,
  description,
  onChange,
  learnMore,
  checked,
  ...props
}) => {
  const {t} = useTranslation();

  const subheader = !learnMore ? (
    description
  ) : (
    <Box>
      {description}
      <Link
        href={learnMore}
        target="_blank"
        underline="always"
        variant="caption"
        sx={{marginLeft: 0.5}}
        rel="noreferrer noopener"
      >
        {t('filters.linkToggleLearnMore')}
      </Link>
    </Box>
  );
  return (
    <CardHeader
      title={title}
      titleTypographyProps={{variant: 'body1', gutterBottom: true}}
      subheader={subheader}
      subheaderTypographyProps={{variant: 'caption', color: 'textPrimary'}}
      action={
        <Switch
          color="primary"
          edge="end"
          checked={checked}
          onChange={onChange}
        />
      }
      sx={{
        paddingX: 0,
        '& .MuiCardHeader-action': {
          alignSelf: 'center',
        },
      }}
      {...props}
    />
  );
};

ToggleFilter.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  learnMore: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ToggleFilter;
